export default "/images/1d24040f85380037abcaa773648247d0.avif";